<template>
  <transition name="slide-fade">
    <v-footer app :light="!$vuetify.theme.dark">
      <span :class="{'text-body-2': true, 'black--text': !$vuetify.theme.dark}">&copy;&nbsp;{{ getYear() }} by &nbsp<a href="https://zetrank.com/"
                                                                                   style="text-decoration: none"
                                                                                   target="_blank">Zetrank</a></span>
      <span :class="{'text-body-2': true, 'black--text': !$vuetify.theme.dark}">&nbsp;- All Rights Reserved.</span>
    </v-footer>
  </transition>
</template>

<script>
import moment from "moment";

export default {
  name: "AppFooter",
  methods: {
    getYear() {
      return moment().year();
    }
  }
}
</script>

<style scoped>

</style>
